import { ACCOUNT_LOGIN, ACCOUNT_LOGOUT, ACCOUNT_REFRESH_CONNEXION, GET_ACCOUNT_DETAILS, RESET_PASSWORD } from '../types/accountTypes';

const accountReducer = function (initialState = {}, action) {
  switch (action.type) {
    case ACCOUNT_LOGIN:
    case ACCOUNT_REFRESH_CONNEXION:
    case GET_ACCOUNT_DETAILS:
      return {
        ...initialState,
        ...action.payload,
      };
    case RESET_PASSWORD:
      return {
        ...initialState,
        isReset: false,
      };
    case ACCOUNT_LOGOUT:
      return {
        refreshToken: undefined,
        expirationTime: undefined,
        accessToken: undefined,
        expirationDate: undefined,
        roles: undefined,
        username: undefined,
        email: undefined,
      };
    default:
      return initialState;
  }
};

export default accountReducer;
